/**
 * VulnZero brand mark — the shield-V used in the favicon, manifest icons,
 * sidebar, and login. Inline SVG so it inherits size/color from Tailwind
 * classes exactly like a heroicon (w-7 h-7, text-accent, ...).
 *
 * Geometry mirrors web/public/favicon.svg.
 */
export default function LogoMark({ className = 'h-7 w-7' }) {
  return (
    <svg className={className} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <defs>
        <linearGradient id="vz-mark-g" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#40e0ff" />
          <stop offset="1" stopColor="#0077cc" />
        </linearGradient>
      </defs>
      <path
        d="M32 9.5 L50.5 16.8 V32.5 C50.5 43.6 42.6 51.2 32 55 C21.4 51.2 13.5 43.6 13.5 32.5 V16.8 Z"
        fill="url(#vz-mark-g)"
      />
      <path
        d="M23.2 21.5 L32 38.8 L40.8 21.5"
        stroke="#0c0e1a"
        strokeWidth="5.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="32" cy="45.2" r="2.8" fill="#0c0e1a" />
    </svg>
  )
}
